import { useEffect, useState } from "react";
// import Map from "../../assets/images/map.png";
import WhiteBox, { WhiteBox2 } from "../../components/partials/box";
import StartMapping from "../../components/modals/select-tool";
// import Nwasco from "../../assets/icons/nwasco.svg";
import WebsiteIcon from "../../assets/icons/website.svg";
import Mail from "../../assets/icons/mail.svg";
import SelectRegion from "../../components/modals/selectregion";
import { DetailsHeader } from "../../components/partials/header";
import DOMPurify from "dompurify";
import { useRawdataStore, useToolsStore } from "../../data/stores/loggerStore";
import { useLocation } from "react-router-dom";
import { apiCall } from "../../data/useFetcher";
import { ToolsKPIsData } from "../../components/tables/tools-table";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { feature } from "topojson-client";
import axios from "axios";
import { toast } from "react-toastify";
import ReactPlayer from "react-player";
import InfoModal from "../../components/modals/infomodal";
import { NormalBtn } from "../../components/partials/buttons";

export const createMarkup = html => {
	return {
		__html: DOMPurify.sanitize(html),
	};
};

export let getCountries = async ({ setCountries }) => {
	try {
		let res = await axios.get(
			`https://restcountries.com/v3.1/all?fields=name,flags,region,capital,timezones,altSpellings,cioc,cca3,cca2,latlng,fifa`,
			{
				headers: {
					Authorization: null,
				},
				baseURL: null,
			}
		);
		console.log({ rd: res }, "countries");
		setCountries(res?.data?.data || res?.data);
	} catch (err) {
		if (err?.response?.status === 429 || err?.response?.status === 405)
			toast.error(err?.response?.data ? err?.response?.data : err?.message);
		console.log({ err });
	}
};

const Dashboard = () => {
	const { state } = useLocation(),
		[datum, setDatum] = useState(null),
		{ data } = useToolsStore(),
		{ getDynamicLogger, data: toolData, getLogger } = useRawdataStore(),
		{ kpidata, regionCountry }: any = useRawdataStore(),
		tools = toolData?.docs?.sort(
			(
				a: { category: { toString: () => string } },
				b: { category: { toString: () => any } }
			) => {
				// Compare the values of the specified key in a case-insensitive manner
				return a?.category?.toString()?.localeCompare(b?.category?.toString());
			}
		),
		[selection, setSelection] = useState(null),
		regionTools = regionCountry?.docs,
		[newTool, setNewTool] = useState<any>(null);

	useEffect(() => {
		if (regionTools && tools) {
			let filteredArray = tools.filter(
				(item1: any) =>
					!regionTools.some((item2: any) => item1?.category === item2?.category)
			);

			filteredArray?.splice(1, 0, ...regionTools);
			setNewTool(filteredArray);

			// console.log({ filteredArray, regionTools, tools });
		}
	}, [regionTools, tools]);

	useEffect(() => {
		apiCall({
			type: "get",
			url: `/api/v1/rawdata?pagination=not`,
			getter: (d: any) => getLogger(d),
		});
		apiCall({
			type: "get",
			url: `/api/v1/tools/manage-region-country?pagination=not&useHardCoded=true`,
			getter: (d: any) => getDynamicLogger(d, "regionCountry"),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		let thisData = data?.docs?.find((it: any) => it?._id === state?._id);
		if (!thisData) thisData = state;
		if (thisData) setDatum(thisData);
		apiCall({
			type: "get",
			url: `/api/v1/tools/retrieve-tool?tool=${state?._id}`,
			getter: (d: any) => {
				thisData = d?.data || d;
				setDatum(thisData);
			},
		});
	}, [data, state]);

	useEffect(() => {
		if (datum) {
			let newSelect: any = {};
			if (datum?.toolSelection?.length > 0) {
				datum?.toolSelection?.map(
					(it: any) =>
						(newSelect[it?.category] =
							it?.category === "APPLICATION LEVEL" ? it?.data?.[0] : it?.data)
				);
			}
			if (Object.keys(newSelect)?.length > 0) {
				setSelection((prev: any) => {
					return {
						...prev,
						...newSelect,
					};
				});
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [datum]);

	const [start, setStart] = useState(true),
		[modal, setModal] = useState(""),
		[tab, setTab] = useState("overview");
	const tabs = ["overview", "about data tool"];

	const contact = [
			{ icon: WebsiteIcon, value: datum?.website },
			{ icon: Mail, value: datum?.contactEmailAddress },
		],
		ownerInfo = [datum?.toolCreatedBy, datum?.toolOwnerAddress],
		webinar = [datum?.webinar];

	let [formInfo, setFormInfo] = useState([]),
		[countries, setCountries] = useState<any>(null),
		[mapCountries, setMapCountries] = useState<any>(null),
		[info, setInfo] = useState<any>(null),
		[newKpiMapper, setNewKpiMapper] = useState<any>(null);

	useEffect(() => {
		let appLevel = datum?.toolSelection?.find(
			(it: any) => it?.category === "APPLICATION LEVEL"
		);
		if (appLevel) {
			apiCall({
				type: "get",
				url: `/api/v1/rawdata/manage-kpis?category=APPLICATION LEVEL&data=${appLevel?.data?.[0]}&pagination=not`,
				getter: (d: any) => getDynamicLogger(d, "kpidata"),
			});
		}
		getCountries({ setCountries });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [datum]);

	useEffect(() => {
		let appLevel = datum?.toolSelection?.find(
			(it: any) => it?.category === "APPLICATION LEVEL"
		);
		if (appLevel && kpidata) {
			setFormInfo([...kpidata?.docs]);
		}
		let countriesLevel = datum?.toolSelection?.find(
			(it: any) => it?.category === "COUNTRY"
		);
		if (countriesLevel) {
			let newCount: any[] = [];
			for (let c = 0; c < countriesLevel?.data?.length; c++) {
				const element = countriesLevel?.data[c];

				let findCountry = countries?.find(
					it => it?.name?.common?.toLowerCase() === element?.toLowerCase()
				);
				let newEle: any = {
					country: element,
				};
				if (findCountry) {
					newEle.short =
						findCountry?.fifa ||
						findCountry?.cioc ||
						findCountry?.cca3 ||
						findCountry?.cca2;
				}
				if (!["all", "global"]?.includes(newEle?.country?.toLowerCase()))
					newCount?.push(newEle);
			}
			setMapCountries(newCount);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [kpidata, datum]);

	useEffect(() => {
		if (formInfo) {
			let someChecker = formInfo?.some(it => it?.upperCategory);
			if (someChecker) {
				let thisData = formInfo;

				let groups = thisData?.reduce((groups, game) => {
					let date = game?.upperCategory;
					if (!groups[date]) {
						groups[date] = [];
					}
					groups[date].push(game);
					return groups;
				}, {});
				const groupArrays = Object.keys(groups).map(date => {
					return {
						category: date,
						data: groups[date],
					};
				});
				setNewKpiMapper({
					level: "3 Step",
					data: groupArrays?.reverse(),
				});
			} else {
				setNewKpiMapper({ level: "2 Step", data: formInfo });
			}
		}
	}, [formInfo]);

	return (
		<section className="w-full bg-[#F8FAFC]">
			<DetailsHeader text={datum?.toolName || "Sanitracker"} />
			<div className="section-container">
				<div className="">
					<div className="">
						<div className="w-full min-h-screen bg-[#F8FAFC]">
							<div
								style={{
									borderBottom: "1px solid #E2E8F0",
								}}
								className="h-16 w-full">
								<div className="flex h-full gap-5">
									{tabs?.map(it => (
										<button
											onClick={() => setTab(it)}
											className={`h-full px-3 text-base capitalize ${
												tab === it
													? "border-b-4 border-b-[#3787FF] text-[#3787FF] font-bold"
													: "font-normal text-[#64748B]"
											}`}>
											{it}
										</button>
									))}
								</div>
							</div>
							{tab === "overview" && (
								<div>
									<div className="w-full mt-8 grid grid-cols-3 gap-5">
										<div
											style={{
												boxShadow: "4px 4px 100px 0px #00000014",
											}}
											className="col-span-2 h-72 flex gap-10 items-center bg-white rounded-lg p-5">
											<div>
												<h4 className="text-base font-medium text-[#000929]">
													Countries using WSH data tools
												</h4>
												{/* <img src={Map} alt="" className="mt-4" />
												 */}
												<MapComponent
													mapCountries={mapCountries}
													datum={datum}
													start={start}
												/>
											</div>
											<div>
												<h5 className="text-base font-medium text-[#000929]">
													{mapCountries?.length}{" "}
													{mapCountries?.length === 1 ? "Country" : "Countries"}{" "}
													Available
												</h5>
												<ul className="list-disc h-60 overflow-y-scroll noscroll list-inside space-y-2 mt-3 text-xs font-normal text-da-blue-600">
													{mapCountries?.map((it: any, i: number) => (
														<li key={i}>{it?.country}</li>
													))}
												</ul>
											</div>
										</div>
										<div className="col-span-1">
											<WhiteBox>
												<h4 className="text-base font-medium text-[#000929]">
													Data Type Generated
												</h4>
												<div className="mt-5 space-y-3">
													{!start && (
														<>
															<div className="flex items-center gap-2">
																<div
																	className={`h-3 rounded-tr-3xl w-12 ${
																		start ? "bg-[#3787FF]" : "bg-[#D2D7D4]"
																	}`}></div>
																{start && (
																	<h6 className="text-sm font-normal text-da-blue-600">
																		Quality of Service KPIs
																	</h6>
																)}
															</div>
															<div className="flex items-center gap-2">
																<div
																	className={`h-3 rounded-tr-3xl w-12 ${
																		start ? "bg-[#3787FF]" : "bg-[#D2D7D4]"
																	}`}></div>
																{start && (
																	<h6 className="text-sm font-normal text-da-blue-600">
																		Quality of Service KPIs
																	</h6>
																)}
															</div>
															<div className="flex items-center gap-2">
																<div
																	className={`h-3 rounded-tr-3xl w-12 ${
																		start ? "bg-[#3787FF]" : "bg-[#D2D7D4]"
																	}`}></div>
																{start && (
																	<h6 className="text-sm font-normal text-da-blue-600">
																		Quality of Service KPIs
																	</h6>
																)}
															</div>
														</>
													)}
													{newKpiMapper?.data?.map((tool, i) => (
														<div key={i} className="flex items-center gap-2">
															<div
																className={`h-3 rounded-tr-3xl w-12 ${
																	start ? "bg-[#3787FF]" : "bg-[#D2D7D4]"
																}`}></div>
															{start && (
																<h6 className="text-sm font-normal text-da-blue-600 capitalize">
																	{tool?.category?.toLowerCase()}
																</h6>
															)}
														</div>
													))}
													<NormalBtn
														text={"View More"}
														onClick={() => {
															setModal("start");
														}}
														className="bg-da-blue-100 text-white mt-auto"
													/>
												</div>
											</WhiteBox>
										</div>
									</div>
									<div className="mt-5 grid grid-cols-3 gap-5">
										{formInfo?.map((tool: any, i: number) => (
											<ToolsKPIsData
												start
												data={tool?.data}
												title={tool?.category}
												key={i}
												formIndex={i}
												prevData={datum?.kpiSelection}
												setInfo={() => setInfo(tool)}
											/>
										))}
									</div>
								</div>
							)}
							{tab === "about data tool" && (
								<div className="mt-8">
									<WhiteBox2 className="w-full">
										<div className="flex gap-6 items-center">
											<img
												src={datum?.image?.url || datum?.logo || ""}
												alt=""
												className={
													datum?.image?.url || datum?.logo ? "w-24" : ""
												}
											/>
											<h6 className="text-base font-medium text-da-blue-600">
												{datum?.toolName}
											</h6>
										</div>
										<div
											className="
																	text-sm font-normal text-da-blue-600 mt-4
																	"
											dangerouslySetInnerHTML={createMarkup(datum?.description)}
										/>
									</WhiteBox2>
									<div className="mt-6 grid grid-cols-3 gap-8">
										<div className="col-span-2">
											<WhiteBox>
												<h4 className="text-base font-medium text-[#000929]">
													Resources
												</h4>
												<div
													style={{
														border: "1px solid #E2E8F0",
													}}
													className="mt-5 h-10 w-full grid grid-cols-3">
													<div className="cols-span-1 border-r border-r-[#E2E8F0] flex justify-start items-center h-full w-full">
														<h4 className="text-sm pl-4 font-medium text-da-blue-600">
															Resource Title
														</h4>
													</div>
													<div className="cols-span-2 h-full flex items-center pl-6">
														<h4 className="text-sm font-medium text-da-blue-600">
															Link
														</h4>
													</div>
												</div>
												{datum?.resources?.map((r: any, i: number) => (
													<div
														key={i}
														style={{
															border: "1px solid #E2E8F0",
														}}
														className="h-10 w-full grid grid-cols-3">
														<div className="cols-span-1 border-r border-r-[#E2E8F0] flex items-center h-full w-full">
															<ul className="list-disc ml-6 list-inside">
																<li className="text-sm font-normal text-da-blue-600">
																	{r?.material || r?.name}
																</li>
															</ul>
														</div>
														<div className="cols-span-2 h-full flex items-center pl-6">
															<a
																href={r?.link}
																target="_blank"
																rel={"noreferrer"}
																className="text-sm font-normal text-da-blue-100 line-clamp-1">
																{r?.link}
															</a>
														</div>
													</div>
												))}
												<div className="mt-5">
													<h4 className="text-base font-medium text-[#000929]">
														Webinar
													</h4>
													<div className="mt-5 space-y-3">
														{webinar?.map(c => (
															<div className="flex items-center gap-2">
																{start && (
																	<div className="w-full h-96">
																		<ReactPlayer
																			url={c}
																			width="100%"
																			height="100%"
																			style={{
																				borderRadius: "24px",
																			}}
																			// style={{ position: "absolute", top: 0, left: 0 }}
																			controls
																		/>
																	</div>
																	// <h6 className="text-sm font-normal text-[#3787FF]">
																	// 	<a href={c}> {c}</a>
																	// </h6>
																)}
															</div>
														))}
													</div>
												</div>
											</WhiteBox>
										</div>
										<div className="col-span-1">
											<WhiteBox2>
												{(datum?.toolCreatedBy || datum?.toolOwnerAddress) && (
													<>
														<h4 className="text-base font-medium text-[#000929]">
															Tool Owner Information
														</h4>
														<div className="my-5 space-y-3">
															{ownerInfo?.map(c => (
																<div className="flex items-center gap-2">
																	<div
																		className={`h-3 rounded-tr-3xl w-12 ${
																			start ? "bg-[#3787FF]" : "bg-[#D2D7D4]"
																		}`}></div>
																	{start && (
																		<h6 className="text-sm font-normal text-da-blue-600">
																			{c}
																		</h6>
																	)}
																</div>
															))}
														</div>
													</>
												)}
												<h4 className="text-base font-medium text-[#000929]">
													Contact Details
												</h4>
												<div className="mt-5 space-y-3">
													{contact?.map(c => (
														<div className="flex items-center gap-2">
															<img src={c?.icon} alt="" className="" />
															{start && (
																<a
																	href={c?.value}
																	target="_blank"
																	rel={"noreferrer"}
																	className="text-sm font-normal text-da-blue-100 line-clamp-1">
																	{c?.value}
																</a>
															)}
														</div>
													))}
												</div>
											</WhiteBox2>
											{datum?.utilities && datum?.utilities?.length > 0 && (
												<div className="py-8">
													<WhiteBox2>
														<h4 className="text-base font-medium text-[#000929]">
															Utilities
														</h4>
														<div className="mt-5 space-y-3">
															{datum?.utilities?.map((c: any, i: any) => (
																<div
																	className="flex items-center gap-2"
																	key={i}>
																	{start && (
																		<span className="text-sm font-normal text-da-blue-600">
																			{c?.address}
																		</span>
																	)}
																</div>
															))}
														</div>
													</WhiteBox2>
												</div>
											)}
										</div>
									</div>
									{datum?.additionalInformation && (
										<WhiteBox2 className="w-full my-8">
											<h4 className="text-base font-medium text-[#000929]">
												Additional Information
											</h4>
											<div
												className="
																	text-sm font-normal text-da-blue-600 mt-4
																	"
												dangerouslySetInnerHTML={createMarkup(
													datum?.additionalInformation
												)}
											/>
										</WhiteBox2>
									)}
								</div>
							)}
						</div>
					</div>
				</div>
				{modal === "start" && (
					<StartMapping
						handleClose={() => setModal("")}
						data={newTool}
						handleComplete={() => {
							// setSelection(da);
							setModal("");
						}}
						readOnly
						defaultSelection={selection}
					/>
				)}
				{modal === "region" && (
					<SelectRegion
						handleClose={() => setModal("")}
						setStart={() => setStart(true)}
					/>
				)}
				{info && (
					<InfoModal
						handleClose={() => setInfo("")}
						title={info?.category || "Infrastructure and Stability"}
						description={info?.description}
					/>
				)}
			</div>
		</section>
	);
};

export default Dashboard;

export const MapComponent = ({ mapCountries, datum, start }) => {
	const [topoData, setTopoData] = useState(null),
		[selectedTool] = useState<any>("toolA");
	const countryColors = {
		available: "#3787FF",
		notAvailable: "#EAEAEA",
	};

	// Updated to include both ISO_A3 and ISO_A2 formats for testing
	const toolAvailability = {
		toolA: ["USA", "CAN", "MEX", "US", "CA", "MX", "KIR", "NGA"], // Ensure KIR is included if needed
		toolB: ["FRA", "DEU", "ITA", "FR", "DE", "IT"],
	};
	useEffect(() => {
		const fetchData = async () => {
			const response = await fetch("/features.json"); // Path to your TopoJSON
			const data = await response.json();
			setTopoData(data); // Store TopoJSON data
		};

		fetchData();
	}, [datum]);
	if (!topoData || !topoData.objects || !topoData.objects.world) return null;
	const geoData = feature(topoData, topoData.objects.world);

	return (
		<div className="mt-3 h-60 w-80 bg-[#F8FAFC] rounded-md">
			<ComposableMap projection="geoMercator">
				<Geographies geography={geoData}>
					{({ geographies }) =>
						geographies.map(geo => {
							const countryCode = geo.id;
							const isAvailable2 = mapCountries
								?.map(it => it?.short)
								.includes(countryCode);
							const isAvailable1 = mapCountries
								?.map(it => it?.country)
								.includes(geo?.properties?.name);
							const isAvailable =
								start && datum
									? isAvailable1 || isAvailable2
									: toolAvailability[selectedTool].includes(countryCode);
							// console.log({geographies});

							return (
								<Geography
									key={geo.rsmKey}
									geography={geo}
									fill={
										isAvailable
											? countryColors.available
											: countryColors.notAvailable
									}
									stroke="#FFFFFF"
									strokeWidth={0.5}
									style={{
										default: {
											fill: isAvailable
												? countryColors.available
												: countryColors.notAvailable,
											outline: "none",
										},
										hover: {
											fill: isAvailable ? "#3787FF" : "#D3D3D3",
											outline: "none",
										},
										pressed: {
											outline: "none",
										},
									}}
								/>
							);
						})
					}
				</Geographies>
			</ComposableMap>
		</div>
	);
};